function isItemSoldOut(item) {
    return Boolean(item?.soldOut);
}

function getSoldOutFacilityNamesForSku(packGroupsAndItems, externalSku) {
    if (!externalSku || !packGroupsAndItems?.length) {
        return [];
    }

    return packGroupsAndItems
        .filter((pg) => pg.allItems?.some((item) => item.externalSku === externalSku && isItemSoldOut(item)))
        .map((pg) => pg.facilityName);
}

function enrichItemWithSoldOutFacilities(item, packGroupsAndItems) {
    return {
        ...item,
        soldOutFacilities: getSoldOutFacilityNamesForSku(packGroupsAndItems, item.externalSku),
    };
}

function mergeCatalogSoldOut(item, allItems) {
    if (!item?.externalSku || !allItems?.length) {
        return item;
    }

    const catalogItem = allItems.find((catalogRow) => catalogRow.externalSku === item.externalSku);
    if (!catalogItem || !isItemSoldOut(catalogItem)) {
        return item;
    }

    return { ...item, soldOut: catalogItem.soldOut };
}

export { enrichItemWithSoldOutFacilities, getSoldOutFacilityNamesForSku, isItemSoldOut, mergeCatalogSoldOut };
